import React, { useState, useEffect, useCallback, useRef } from 'react';
import style from './NoticeBoradCardDetail.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import { useLocation } from 'react-router-dom';

import ToastPopup from '../../../../components/comm/ToastPopup';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import '../../../../assets/css/ckEditor.css';

const NoticeBoradCardDetail = () => {

    const user = JSON.parse(sessionStorage.getItem("loginUser"));
    const location = useLocation();
    const { state } = location;

    const [showNativePlayer, setShowNativePlayer] = useState(false);
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const contentRef = useRef(null);

    const [searchNtt] = useState({
        cntsNttId: state?.cntsNttId ?? null,
        usrInfoId: user?.usrInfoId ?? null,
        cntsSndngHistId: state?.idx ?? null,
        cnfrmAt: state?.cnfrmAt ?? null
    });

    const [contentsInfo, setContentsInfo] = useState({
        cntsSj: "",
        cntsCn: "",
        rgstMthdCd: "",
        cntsUrl: ""
    });

    // 새창 열기 
    const handleOnJoinMeeting = (joinUrl) => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: joinUrl
            }));
        } else {
            window.open(joinUrl, '_blank', 'noopener,noreferrer');
        }
    };


    // 모달 닫힘 이벤트 리스너
    useEffect(() => {
        const handleMessage = (event) => {
            try {
                const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                if (data.type === 'CLOSE_IFRAME_WEBVIEW') {
                    setShowNativePlayer(false);
                }
            } catch (e) {
                console.error('메시지 파싱 오류:', e);
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    // 콘텐츠 정보 가져오기
    const getContentsInfo = useCallback(async () => {
        const url = "/homecare/guide/retrieveContentsInfo";
        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                'Authorization': 'Bearer ' + jToken,
            }
        };

        try {
            const res = await axiosApi.post(url, searchNtt, reqOptions);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setContentsInfo(res.data.result.contInfo);
            } else {
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        } catch (err) {
            console.error('콘텐츠 조회 오류:', err);
            setToastMessage('콘텐츠를 불러올 수 없습니다.');
            setToast(true);
        }
    }, []);

    // 초기 데이터 로드
    useEffect(() => {
        if (!searchNtt?.cntsNttId) {
            setToastMessage('잘못 된 접근입니다.');
            setToast(true);
            return;
        }
        getContentsInfo();
    }, [searchNtt?.cntsNttId]);

    // Android에서 자동으로 네이티브 플레이어 실행
    useEffect(() => {
        if (window.nativeAppPlatform?.isAndroid &&
            contentsInfo.rgstMthdCd === 'U' &&
            contentsInfo.cntsUrl &&
            !showNativePlayer) {

            setShowNativePlayer(true);
            window.ReactNativeWebView?.postMessage(JSON.stringify({
                type: 'OPEN_IFRAME_WEBVIEW',
                url: contentsInfo.cntsUrl
            }));
        }
    }, [contentsInfo, showNativePlayer]);


    // 하이퍼링크  새창 열기 
    useEffect(() => {
        const container = contentRef.current;
        if (!container) return;

        const handleClick = (e) => {
            const anchor = e.target.closest('a');
            if (!anchor || !container.contains(anchor)) return;

            e.preventDefault();
            e.stopPropagation();

            const url = anchor.getAttribute('href');
            if (url) {
                handleOnJoinMeeting(url);
            }
        };

        container.addEventListener('click', handleClick);
        return () => container.removeEventListener('click', handleClick);
    }, [contentsInfo.cntsCn]);

    return (
        <>
            <HeadSub title="상세 보기" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-pad="normal">

                    <strong className={style['title']}>{contentsInfo.cntsSj}</strong>

                    {contentsInfo.rgstMthdCd === 'U' && (
                        <div className={style['card-wrap']}>
                            <div className={style['card-frame']}
                                style={window.nativeAppPlatform ? {
                                    position: 'relative',
                                    width: '100%',
                                    paddingBottom: '56.25%',
                                    overflow: 'hidden'
                                } : {}}
                            >
                                {window.nativeAppPlatform?.isAndroid && !showNativePlayer ? (
                                    <div
                                        onClick={() => {
                                            setShowNativePlayer(true);
                                            window.ReactNativeWebView?.postMessage(JSON.stringify({
                                                type: 'OPEN_IFRAME_WEBVIEW',
                                                url: contentsInfo.cntsUrl
                                            }));
                                        }}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            background: '#f5f5f5',
                                            height: '100%'
                                        }}
                                    >
                                        <p style={{ fontSize: '16px', color: '#666' }}>
                                            컨텐츠가 안 보이면 클릭 해주세요
                                        </p>
                                    </div>
                                ) : (
                                    <iframe
                                        src={contentsInfo.cntsUrl}
                                        frameBorder="0"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen
                                        title="콘텐츠"
                                        style={window.nativeAppPlatform ? {
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%'
                                    } : {}}
                                    />
                                )}
                            </div>
                        </div>
                    )}

                    {contentsInfo.rgstMthdCd === 'E' && (
                        <div
                            ref={contentRef}
                            className="ck-content desc"
                            data-content="ck-content"
                            dangerouslySetInnerHTML={{ __html: contentsInfo.cntsCn }}
                        />
                    )}

                </div>
            </div>

            {toast && (
                <ToastPopup
                    setToast={setToast}
                    position="center"
                    message={toastMessage}
                />
            )}
        </>
    );
};

export default NoticeBoradCardDetail;